import React from 'react';
import styled, { css } from 'styled-components';

import { useTypedSelector } from '@/store/store';
import { selectSinglePost } from '@/store/reducers/single-post';
import { colors } from '@/constants/theme';
import Link from '@/components/Link';
import { media } from '@/utils/mixin';

function Promotion() {
  const page = useTypedSelector(selectSinglePost);

  if (!page) {
    return null;
  }

  return (
    <Component>
      <Title>{page.ctaTitle}</Title>
      <Buttons>
        {page.ctaButtons.map(({ link, mode, label }, index) => (
          <CtaButton
            key={index}
            to={link}
            target={`${mode === 'linkNewTab' ? '_blank' : '_self'}`}
          >
            {label}
          </CtaButton>
        ))}
      </Buttons>
    </Component>
  );
}

export default Promotion;

const Component = styled.div`
  position: sticky;
  top: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Title = styled.span`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: ${(props) => props.theme.black200};

  ${media.tablet(css`
    font-size: 28px;
    line-height: 36px;
  `)}

  ${media.mobile(css`
    font-size: 24px;
    line-height: 32px;
  `)}
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  ${media.tablet(css`
    flex-direction: row;
  `)}

  ${media.mobile(css`
    flex-direction: column;
  `)}
`;

const CtaButton = styled(Link)`
  position: relative;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  height: 40px;
  padding: 11px 26px;
  width: 240px;
  max-width: 100%;
  background: ${colors.main};
  border-radius: 20px;
  text-transform: uppercase;
  text-align: center;
  color: ${colors.white};

  &:not(:first-child) {
    margin-top: 10px;

    ${media.tablet(css`
      margin-top: 0;
      margin-left: 10px;
    `)}

    ${media.mobile(css`
      margin-left: 0;
      margin-top: 10px;
    `)}
  }

  &:hover {
    opacity: 0.7;
  }
`;
